import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import ExclamationIcon from "assets/Error/ExclamationIcon.svg";

const useStyles = makeStyles(() => ({
  errorMsgContainer: {
    marginTop: "3px",
    position: "absolute"
  },
  icon: {
    margin: "0 3px",
    width: "6px",
    height: "10px",
    marginTop: "-1.3px",
    alignSelf: "flex-start"
  }
}));

const ErrorLabel = props => {
  const { message, className } = props;
  const classes = useStyles();

  return (
    <>
      <div className={`errorText ${classes.errorMsgContainer} ${className}`}>
        <img className={classes.icon} src={ExclamationIcon} alt='error_label'/>
        {message}
      </div>
    </>
  );
};

export default ErrorLabel;
